import { Patient } from './patient';
import { domainTrace } from '../diagnostics/domainTrace';

/**
 * Reconciles every StructureSet's domain Roi[] wrapper collection with
 * the underlying DicomStructureSet after Patient/StructureSet have been
 * loaded from DICOM. Idempotent — existing wrappers (and their RoiIds)
 * are preserved; only unwrapped DicomRois get new wrappers.
 *
 * The StructureSet constructor already wraps the DicomRois present at
 * construction, so this is a safety net for ingest flows that add
 * DicomRois at the dicom level after the domain entity was created.
 * Safe to call before or after attachTracker: new wrappers inherit the
 * structure set's tracker when one is attached.
 */
export function completeHydration(patient: Patient): void {
    const roiCountBySs: Record<string, number> = {};
    for (const ss of patient.structureSets) {
        ss.syncRoiObjects();
        roiCountBySs[ss.id] = ss.rois.length;
    }
    domainTrace.hydration('complete', {
        structureSetCount: patient.structureSets.length,
        roiCountBySs,
    });
}
